import type { IActionsMenuAction, IButtonTypes } from "@/shared/common/types";
import { useMediaQuery } from "@/shared/hooks";
import { IconMore } from "@ab.uitools/ui-library";
import { Button } from "@ab.uitools/ui-library/components/Button";
import { Menu } from "@ab.uitools/ui-library/components/Menu";
import { Positions } from "@ab.uitools/ui-library/components/Tooltip/types";
import { type MouseEvent, useMemo, useState } from "react";

interface Props {
  isOpen: boolean;
  isInTable?: boolean;
  actions: IActionsMenuAction[];
  openMenu: () => void;
  closeMenu: () => void;
  buttonType?: IButtonTypes;
  parentClass?: string;
  position?: Positions;
}

export const ActionsMenu = ({
  isOpen,
  isInTable,
  actions,
  openMenu,
  closeMenu,
  buttonType = "secondary",
  parentClass,
  position = Positions.BOTTOM_LEFT,
}: Props) => {
  const [ref, setRef] = useState<HTMLDivElement | null>(null);
  const isDesktop = useMediaQuery();

  const handleButtonClick = (e: MouseEvent) => {
    const parent = isInTable ? e.currentTarget.closest("td") : null;
    if (isOpen) {
      closeMenu();
      if (parent) {
        parent.style.zIndex = "1";
      }
    } else {
      openMenu();
      if (parent) {
        parent.style.zIndex = "2";
      }
    }
  };

  const containerRef = useMemo(() => {
    if (parentClass) {
      return document.querySelector(`.${parentClass}`);
    }
  }, []);

  const onCloseMenu = () => {
    if (isOpen) {
      if (containerRef && isInTable) {
        const positionedTd = Array.from(
          containerRef.querySelectorAll("td")
        ).find(
          (td) => window.getComputedStyle(td).zIndex === "2"
        );
        if (positionedTd) {
          positionedTd.style.zIndex = "1";
        }
      }
      closeMenu();
    }
  };

  return (
    <div ref={setRef}>
      <Menu
        containerRef={containerRef as HTMLElement}
        parentRef={ref}
        additionalRef={ref}
        onClose={onCloseMenu}
        isOpen={isOpen}
        position={position}
        menuItems={actions}
      />
      <Button
        onClick={handleButtonClick}
        iconProps={{ Component: IconMore }}
        size={isDesktop ? "large" : "medium"}
        type={buttonType}
        dataId="more-icon-btn"
      />
    </div>
  );
};
